export const MAX_LICENCE_QTY = 5;

export const NAT_TYPES = {
  natToIp: 'IP',
  natToVm: 'VM_NIC',
};
